import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Label from './Form/Label';
import InputGroup from './Form/InputGroup';
import InputBox from './Form/InputBox';
import classNames from 'classnames';
import estadoSuscripciones from '../../../Models/EstadoSuscripciones';
import InputInfoSuscription from './Form/InputInfoSuscription';
import InfoInput from './Form/InfoInput';
import CallbackArticle from '../Modules/CallbackArticle';
import FormRow from './Form/FormRow';
import FormCol from './Form/FormCol';

const propTypes = {
    suscripcion: PropTypes.object.isRequired,
    onSuscripSelected: PropTypes.func,
};

const InfoSuscription = (props) => {
    const { suscripcion, onSuscripSelected, className, title } = props;
    const classes = classNames('suscripcion', className);

    return (
        <div className={classes}>
            <legend className="--mb-32">{title}</legend>
            <FormRow>
                <FormCol>
                    <InputInfoSuscription input={<InfoInput>{suscripcion.NombreAmigable}</InfoInput>} /> 
                </FormCol>
            </FormRow>
        </div>
    );
};

InfoSuscription.propTypes = propTypes;

export default InfoSuscription;
